<div class="pb-4 pb-lg-0">
    <span class="pt-5 col-12" translate=Settings.ApplicationReasonsLocationsSection.Location><app-info-button labelName="Settings.ApplicationReasonsLocationsSection.LocationTooltip"></app-info-button></span>
    <div class="mb-3 mt-2 mx-0 p-1 col-12 row text-wrap border rounded lh-base">
        <div class="d-table form-check form-switch">
            <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="authenticatorapp" name="authenticatorapp" (change)="toggleShowSigningLocation($event)" [checked]="showLocation">
            <label class="form-check-label pt-1 col-10" for="authenticatorapp" translate="Settings.ApplicationReasonsLocationsSection.EnableLocationForSigning"></label>
        </div>
    </div>
</div>

<div class="w-auto row row-cols-12 mb-3">
    <ul class="list-group ps-2 pe-2 ms-1 me-1" cdkDropList (cdkDropListDropped)="locationDropped($event)">
        <li class="list-group-item d-block p-1" *ngFor="let location of locations" [cdkDragDisabled]="locations.length < 2" cdkDrag>
            <app-locationlistitem [location]="location" (RemoveLocation)="removeLocation($event)"></app-locationlistitem>
        </li>
    </ul>
</div>

<div class="me-1">
    <form [formGroup]="form" (ngSubmit)="addLocation()">
        <div class="input-group">
            <input type="text" class="form-control" id="location" (keyup)="fieldChange('location')" formControlName="location" pattern="^['()\sa-zA-ZÀ-ÿ\u00f1\u00d10-9.-]*$" autocomplete="off" placeholder="{{'Settings.ApplicationReasonsLocationsSection.EnterLocation' | translate}}">
            <button class="btn btn-sm default-button" type="submit" translate="Button.AddLocation" [disabled]="!form.valid || alreadyExistingLocationName"></button>
            <ng-container *ngIf="alreadyExistingLocationName">
                <div class="invalid-feedback"  translate="Error.LocationAlreadyExist"></div>
            </ng-container>
        </div>
        <app-formcontrol-error-messages [forControl]="newLocationControl"></app-formcontrol-error-messages>
    </form>
</div>